var DefaultImageReceiver = /** @class */ (function () {
    function DefaultImageReceiver(supplementaryCanvas) {
        this.supplementaryCanvas = supplementaryCanvas;
    }
    DefaultImageReceiver.prototype.unload = function () { };
    return DefaultImageReceiver;
}());
export { DefaultImageReceiver };
//# sourceMappingURL=imageReceiver.js.map